"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configBaseUrl = exports.getBaseUrl = void 0;
const candy_shop_types_1 = require("@liqnft/candy-shop-types");
const axios_1 = __importDefault(require("axios"));
const BACKEND_STAGING_URL = 'https://ckaho.liqnft.com/api';
const BACKEND_PROD_URL = 'https://candy-shop.liqnft.com/api';
const axiosInstance = axios_1.default.create({
    headers: {
        'Content-Type': 'application/json'
    }
});
exports.default = axiosInstance;
let interceptorEvents = [];
const getBaseUrl = (env) => {
    switch (env) {
        case candy_shop_types_1.Blockchain.SolMainnetBeta:
        case candy_shop_types_1.Blockchain.Eth:
        case candy_shop_types_1.Blockchain.Polygon:
            return BACKEND_PROD_URL;
        default:
            return BACKEND_STAGING_URL;
    }
};
exports.getBaseUrl = getBaseUrl;
const configBaseUrl = (baseUrl) => {
    if (interceptorEvents.length) {
        interceptorEvents.forEach((id) => {
            axiosInstance.interceptors.request.eject(id);
        });
        interceptorEvents = [];
    }
    const interceptorEvent = axiosInstance.interceptors.request.use((config) => {
        config.baseURL = baseUrl;
        return config;
    }, (error) => {
        // Do something with request error
        return Promise.reject(error);
    });
    interceptorEvents.push(interceptorEvent);
};
exports.configBaseUrl = configBaseUrl;
